<hlm-popover
  class="w-full"
  align="start"
  [state]="overlayState()"
  (stateChanged)="onStateChanged($event)"
>
  <button
    #trigger
    type="button"
    hlmPopoverTrigger
    class="status-dropdown__trigger"
    [style]="style()"
    [class.status-dropdown__trigger--open]="selectedModifier() === 'open'"
    [class.status-dropdown__trigger--resolved]="selectedModifier() === 'resolved'"
    [class.status-dropdown__trigger--closed]="selectedModifier() === 'closed'"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen()"
    (click)="onTriggerClick()"
    (keydown.space)="$event.preventDefault()"
  >
    @if (ariaLabel()) {
      <span class="visually-hidden">{{ ariaLabel() }}</span>
    }
    <span class="status-dropdown__label">
      @if (selectedOption(); as option) {
        {{ option.labelKey | translate }}
      } @else {
        {{ placeholder() || ('status-dropdown.not-set' | translate) }}
      }
    </span>
    <ocp-themed-icon
      class="status-dropdown__chevron"
      [name]="chevronIcon()"
      [size]="chevronSize()"
    />
  </button>

  <hlm-popover-content *hlmPopoverPortal class="w-fit p-2.5" [style.min-width]="triggerWidth()">
    <div
      class="status-dropdown__list"
      role="listbox"
      [attr.aria-activedescendant]="activeDescendant()"
      [attr.aria-label]="'status-dropdown.set-status' | translate"
    >
      @for (option of options; track trackByValue($index, option); let i = $index) {
        <div
          [id]="getOptionId(i)"
          role="option"
          class="status-dropdown__option"
          [class.status-dropdown__option--selected]="isSelected(option)"
          [class.status-dropdown__option--focused]="focusedIndex() === i"
          [attr.aria-selected]="isSelected(option)"
          [attr.tabindex]="focusedIndex() === i ? 0 : -1"
          (click)="selectOption(option, $event)"
          (keydown)="onOptionKeydown($event, option, i)"
        >
          <span class="status-dropdown__checkmark-area">
            @if (isSelected(option)) {
              <ocp-themed-icon
                class="status-dropdown__checkmark"
                name="checkmark.svg"
                [size]="16"
              />
            }
          </span>
          <span
            class="status-dropdown__option-pill"
            [class.status-dropdown__option-pill--open]="option.modifier === 'open'"
            [class.status-dropdown__option-pill--resolved]="option.modifier === 'resolved'"
            [class.status-dropdown__option-pill--closed]="option.modifier === 'closed'"
          >
            {{ option.labelKey | translate }}
          </span>
        </div>
      }
    </div>
  </hlm-popover-content>
</hlm-popover>
